import { Button, Group, Modal, Text } from '@mantine/core';
import { IconDeviceFloppy, IconPlus } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import ProductFeedFormFields from '../ProductFeeds/ProductFeedFormFields';

const CustomizeProductFeedModal = ({ isOpen, close, productFeed: passedProductFeed, onSelect, forType }) => {
  const { accountId, domainId } = useParams();
  const fetch = useFetch();
  const tabs = ['general', 'boostsAndFiltrs'];
  const [tab, setTab] = useState(tabs[0]);
  const [productFeed, setProductFeed] = useState(passedProductFeed);
  const [error, setError] = useState();

  useEffect(() => {
    setProductFeed(passedProductFeed);
  }, [passedProductFeed]);

  const update = (productFeed) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/productFeeds/${productFeed.id}`, {
      method: 'PUT',
      body: JSON.stringify(productFeed),
    })
      .then(({ productFeed }) => {
        onSelect(productFeed.id, productFeed);
        close();
        setError(undefined);
      })
      .catch(setError);
  };

  const create = (productFeed) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/productFeeds`, {
      method: 'POST',
      body: JSON.stringify(productFeed),
    })
      .then(({ productFeed }) => {
        onSelect(productFeed.id, productFeed);
        close();
        setError(undefined);
      })
      .catch(setError);
  };

  if (productFeed === null) {
    return <ErrorMessage message="Product feed does not exist!" />;
  }
  if (productFeed === undefined) {
    return '';
  }

  return (
    <Modal
      size="xl"
      opened={isOpen}
      onClose={() => {
        close();
        setError(undefined);
      }}
      title="Customize product feed"
    >
      <ProductFeedFormFields productFeed={productFeed} setProductFeed={setProductFeed} tab={tab} setTab={setTab} />

      <Text c="dimmed" ta="right" mt="md">
        Please note that modifying this product feed will have an impact on all the elements that utilize it. If you
        would like to apply the changes only to this {forType}, please click on "Save as new".
      </Text>

      <Group justify="flex-end" mt="md">
        <Button
          variant="default"
          onClick={() => {
            setError(undefined);
            close();
          }}
        >
          Cancel
        </Button>
        <Button
          variant="light"
          color="cyan"
          disabled={!productFeed.name || !productFeed.scope || productFeed.algorithm === undefined}
          onClick={() => create(productFeed)}
          leftSection={<IconPlus size={16} />}
        >
          Save as new
        </Button>
        <Button
          disabled={
            !productFeed.name ||
            !productFeed.scope ||
            productFeed.algorithm === undefined ||
            (productFeed.algorithm === 'latestEventProducts' && !productFeed.contextAction)
          }
          onClick={() => update(productFeed)}
          leftSection={<IconDeviceFloppy size={16} />}
        >
          Update
        </Button>
      </Group>
      {error && <ErrorMessage message={error.message} />}
    </Modal>
  );
};

export default CustomizeProductFeedModal;
